var map = {
	"./bet-tnc-cn.svg": 969,
	"./fifa-tnc-cn.svg": 970,
	"./leaderboard-tnc-cn.svg": 971,
	"./lucky-tnc-cn.svg": 972,
	"./term-condition-bm.svg": 973,
	"./term-condition-cn.svg": 974,
	"./term-condition-id.svg": 975,
	"./term-condition-vn.svg": 976,
	"./term-condition.svg": 977,
	"./term-content.png": 978,
	"./term-footer.png": 979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;